import { render, staticRenderFns } from "./StatisticsLine.vue?vue&type=template&id=8af1ec96&scoped=true"
import script from "./StatisticsLine.vue?vue&type=script&lang=js"
export * from "./StatisticsLine.vue?vue&type=script&lang=js"
import style0 from "./StatisticsLine.vue?vue&type=style&index=0&id=8af1ec96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af1ec96",
  null
  
)

export default component.exports